<template>
    <div v-if="plaidURL" class="min-h-screen relative">
        <iframe :src="plaidURL" style="position: absolute; width: 100%; height: 100%;" frameborder="0"></iframe>
    </div>
</template>

<script>
import { onMounted } from '@vue/runtime-core'
export default {
    props: ['plaidURL'],
    setup(){
        onMounted(() => {
            window.addEventListener('message', postMessage)
        })

        function postMessage(event){
            const eventData = event.data || event.message

            console.log(eventData)
        }
    }
}
</script>

<style>

</style>
